module.exports = __webpack_public_path__ + "static/media/home-banner-img-1.b29657f6.jpg";